/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One highlight bullet; `text` is plain copy — the FE owns icons/emphasis.
 */
export type HighlightBullet = {
  kind: HighlightBullet.kind;
  text: string;
};
export namespace HighlightBullet {
  export enum kind {
    PROVIDER = 'provider',
    MEDICATION = 'medication',
    CARE = 'care',
    RISK = 'risk',
    PRIORITY = 'priority',
    SUMMARY = 'summary',
  }
}
